// removed by extract-text-webpack-plugin
module.exports = {"videoBg":"_2ubF6kLXEPwi2Jy1DqWPU1","video":"_1FGKaFXUMPLsKF3Bbmqtrm","videoWrapper":"_29Ej1lI3Al1l_AVTZ5WgPt","fixed":"s-lzJpQRKVrlxualWwTT","hasGradient":"_2TKTqgyXlDMov_Pds9KXZO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Video/video.module.scss
// module id = 817
// module chunks = 0